export default __webpack_public_path__ + "static/media/defaultGif.5f5e9ba8.gif";